// Трекинг: единая точка отправки событий в GTM dataLayer.
// Деньги сюда приходят уже в долларах (dollars) - GA4 value ждёт $,
// в коде и на бэке цены в центах.
// dataLayer создаёт GTM-сниппет в head (gtm_id задан); нет сниппета -
// track() молча ничего не делает: трекинг выключен целиком.
// Лежит в utils/, а НЕ в plugins/: чанк plugins линкуют не все страницы
// (каталог и главная - нет), модуль оттуда на них не загрузился бы.

// Центы -> доллары: 999 -> 9.99
export function dollars( cents ) {
    return Math.round( Number( cents ) || 0 ) / 100;
}

// ecommerce: null перед ecommerce-событием, иначе GTM тянет items[] прошлого
export function track( event, params = {}, ecommerce = null ) {

    try {

        if( ! window.dataLayer )
            return;

        if( ecommerce )
            window.dataLayer.push({ ecommerce: null });

        const payload = { event, ...params };

        if( ecommerce )
            payload.ecommerce = ecommerce;

        window.dataLayer.push( payload );

    } catch( e ) {
        // трекинг не должен ломать страницу
    }
}

// ===== view_item_list =====
// Контракт разметки: список = любой элемент с data-track-list="Название" (сетки выдачи и категорий,
// полки, спонсорские блоки); позиция = [data-pid] с data-name и data-price (центы, эффективная цена).
// Список без названия не отправляется. Классы вёрстки в поиске списков не участвуют.
// Группировка: списки с одинаковым data-track-group="ключ" уходят ОДНИМ событием на ключ (главная:
// data-track-group="home_shelf" на полках, "home_spotlight" на спонсорских блоках - два события).
// Разные ключи - разные события; списки без атрибута - каждый своим событием.
// Внутри события список различает item_list_* на позиции. Сам ключ группы в GA4 не уходит.
const LIST_SELECTOR = '[data-track-list]';

function listName( container ) {
    return ( container.dataset.trackList || '' ).trim();
}

function listId( name ) {
    return name.toLowerCase().replace( /[^a-z0-9]+/g, '_' ).replace( /^_|_$/g, '' );
}

// Позиции одного списка: без дублей, index - позиция в списке (start - сдвиг при Load More).
// item_list_* лежат и на самой позиции: так в одном событии едут несколько списков.
function listItems( name, cards, start = 0 ) {

    if( ! name )
        return [];

    const id    = listId( name );
    const seen  = new Set();
    const items = [];

    cards.forEach( card => {

        if( ! card.dataset.pid || seen.has( card.dataset.pid ) )
            return;

        seen.add( card.dataset.pid );

        items.push({
            item_id        : String( card.dataset.pid ),
            item_name      : card.dataset.name || '',
            price          : dollars( card.dataset.price ),
            index          : start + items.length,
            item_list_id   : id,
            item_list_name : name,
        });
    } );

    return items;
}

// GA4 принимает до 200 позиций в событии - больше режем на несколько
const MAX_ITEMS = 200;

function pushItemLists( items ) {

    for( let i = 0; i < items.length; i += MAX_ITEMS ) {

        const chunk     = items.slice( i, i + MAX_ITEMS );
        const ids       = new Set( chunk.map( item => item.item_list_id ) );
        const ecommerce = { items: chunk };

        // в событии один список - стандартные поля GA4 на уровне события
        if( ids.size === 1 ) {
            ecommerce.item_list_id   = chunk[0].item_list_id;
            ecommerce.item_list_name = chunk[0].item_list_name;
        }

        track( 'view_item_list', {}, ecommerce );
    }
}

// Один view_item_list по набору карточек контейнера (start - сдвиг индекса при Load More)
export function trackCards( container, cards, start = 0 ) {

    pushItemLists( listItems( listName( container ), cards, start ) );
}

// Все ещё не отправленные списки страницы (выдача, полки, спонсорские блоки):
// с data-track-group - одним событием на группу, без атрибута - по событию на список
export function trackItemLists( root = document ) {

    const groups = new Map();

    root.querySelectorAll( LIST_SELECTOR ).forEach( container => {

        if( container.__listTracked )
            return;

        container.__listTracked = true;

        const items = listItems( listName( container ), [ ...container.querySelectorAll('[data-pid]') ] );
        const key   = container.dataset.trackGroup;

        if( key )
            groups.set( key, ( groups.get( key ) || [] ).concat( items ) );
        else
            pushItemLists( items );
    } );

    groups.forEach( items => pushItemLists( items ) );
}

export default track;
